module.exports = __webpack_public_path__ + "img/tab_gongnue_low.2b398f81.png";